import { ColumnTypeEnum } from '@y42/json-schema';

export class JsonExtractorModel {
  constructor(
    public target = '',
    public source = '',
    public source_type = '',
    public key = '',
    public key_index = -1,
    public output_type: ColumnTypeEnum = ColumnTypeEnum.String,
  ) {}
}
